import { Box } from "@mui/material";
import lottie from "lottie-web";
import React, { useEffect, useState, useRef } from "react";

const LottieAnimation = ({ animationData, sx, config={} }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const animationInstance = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData,
      config
    });
    return () => animationInstance.destroy();
  }, [animationData,config]);

  return <Box ref={containerRef} sx={{ width: 100, height: 100, ...sx }} />;
};

export default LottieAnimation;